import * as StoreUtil from '../util/InClientStoreUtil';
import InstallAppRequest from 'owa-service/lib/contract/InstallAppRequest';
import InstallExtensionJsonRequest from 'owa-service/lib/contract/InstallExtensionJsonRequest';
import installExtensionJsonRequestFactory from 'owa-service/lib/factory/installExtensionJsonRequest';
import InstallExtensionJsonResponse from 'owa-service/lib/contract/InstallExtensionJsonResponse';
import installExtensionOperation from 'owa-service/lib/operation/installExtensionOperation';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getClientVersion } from 'owa-session-store';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'InstallOutlookWebExt',
        (data: any, responseMethod: Function) => {
            InstallOutlookWebExt(data).then(response => {
                if (response.Body.ResponseClass.toString() == 'Error') {
                    responseMethod(
                        [
                            response.Body.MessageText.toString(),
                            response.Body.ResponseCode.toString(),
                        ],
                        -1
                    );
                } else {
                    const extensionAssetId = response.Body.Extension
                        ? response.Body.Extension.MarketplaceAssetID
                        : data[1];
                    const wasFirstInstall = response.Body.WasFirstInstall ? true : false;
                    responseMethod([extensionAssetId, wasFirstInstall], 0);
                    StoreUtil.updateAddinSurface();
                }
            });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function InstallOutlookWebExt(data: any): Promise<InstallExtensionJsonResponse> {
    const Body: InstallAppRequest = {
        __type: 'InstallAppRequest:#Exchange',
        MarketplaceAssetId: data[1],
        MarketplaceContentMarket: data[0],
        Client: 'WAC_Outlook',
        ClientVersion: getClientVersion(),
        SendWelcomeEmail: true,
        ManifestUrl: null,
        Manifest: null,
    };
    const installRequest: InstallExtensionJsonRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Body: Body,
    };

    const params: InstallExtensionJsonRequest = installExtensionJsonRequestFactory(installRequest);
    const fetchOptions = createOverrideOptions();

    return installExtensionOperation(params, fetchOptions);
}
